import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth/_selectors/auth.selectors';

@Injectable({ providedIn: 'root' })
export class TimelineService {
  authToken;
  companyId;
  loadTimeline$ = new BehaviorSubject<any | ''>('');

  constructor(private httpClient: HttpClient, private store: Store<AppState>) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }

  findSentTimelines(term, type, fromDate, toDate, sessions, id?: number): Observable<any> {
    if (!term) {
      term = '';
    }
    let params =
      '?sort=updated,DESC' +
      '&communication_type=' +
      type +
      '&search_term=' +
      term +
      '&from_date=' +
      toDate +
      '&to_date=' +
      fromDate;
    sessions.forEach((x) => (params += `&session_type=${x}`));
    return this.httpClient.get<any>(
      environment.TIMELINE_BASE +
        '/companies/' +
        this.companyId +
        '/communication/sent_merge_received/contact/' +
        id +
        params,
    );
  }

  getSessionContactLog(contactId) {
    return this.httpClient.get<any>(
      `${environment.TRACKER_BASE}/companies/${this.companyId}/sessions/contact/${contactId}`,
    );
  }
}
